// Import API service
import { adminApi } from '@/services/api'

// Initial state
const state = {
  systemStats: null,
  systemReport: null,
  systemActivity: [],
  loading: false,
  error: null
}

// Getters
const getters = {
  systemStats: state => state.systemStats,
  systemReport: state => state.systemReport,
  systemActivity: state => state.systemActivity,
  isLoading: state => state.loading,
  error: state => state.error
}

// Mutations
const mutations = {
  SET_SYSTEM_STATS(state, stats) {
    state.systemStats = stats
  },
  SET_SYSTEM_REPORT(state, report) {
    state.systemReport = report
  },
  SET_SYSTEM_ACTIVITY(state, activity) {
    state.systemActivity = activity
  },
  SET_LOADING(state, status) {
    state.loading = status
  },
  SET_ERROR(state, error) {
    state.error = error
  }
}

// Actions
const actions = {
  async fetchSystemStats({ commit }) {
    commit('SET_LOADING', true)
    try {
      const response = await adminApi.getSystemStats()
      commit('SET_SYSTEM_STATS', response.data)
      commit('SET_ERROR', null)
    } catch (error) {
      console.error('Error fetching system stats:', error)
      commit('SET_ERROR', 'Failed to load system statistics')
    } finally {
      commit('SET_LOADING', false)
    }
  },

  async fetchSystemReport({ commit }, params = {}) {
    commit('SET_LOADING', true)
    try {
      const response = await adminApi.getSystemReport(params)
      commit('SET_SYSTEM_REPORT', response.data)
      commit('SET_ERROR', null)
    } catch (error) {
      console.error('Error fetching system report:', error)
      commit('SET_ERROR', 'Failed to load system report')
    } finally {
      commit('SET_LOADING', false)
    }
  },

  async fetchSystemActivity({ commit }, params = {}) {
    commit('SET_LOADING', true)
    try {
      const response = await adminApi.getSystemActivity(params)
      commit('SET_SYSTEM_ACTIVITY', response.data.activity || [])
      commit('SET_ERROR', null)
    } catch (error) {
      console.error('Error fetching system activity:', error)
      commit('SET_ERROR', 'Failed to load system activity')
    } finally {
      commit('SET_LOADING', false)
    }
  },

  async exportSystemTransactions({ commit }, params = {}) {
    commit('SET_LOADING', true)
    try {
      const response = await adminApi.exportSystemTransactions(params)
      
      // Create download link
      const blob = new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' })
      const url = window.URL.createObjectURL(blob)
      const link = document.createElement('a')
      link.href = url
      
      // Generate filename
      const startDate = params.start_date || new Date().toISOString().split('T')[0]
      const endDate = params.end_date || new Date().toISOString().split('T')[0]
      link.download = `system_transactions_${startDate}_to_${endDate}.xlsx`
      
      // Trigger download
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
      window.URL.revokeObjectURL(url)
      
      commit('SET_ERROR', null)
      return { success: true, message: 'Export completed successfully' }
    } catch (error) {
      console.error('Error exporting system transactions:', error)
      commit('SET_ERROR', 'Failed to export system transactions')
      return { success: false, message: 'Failed to export system transactions' }
    } finally {
      commit('SET_LOADING', false)
    }
  },

  async refreshAllData({ dispatch }) {
    await Promise.all([
      dispatch('fetchSystemStats'),
      dispatch('fetchSystemActivity')
    ])
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
} 